// Specific applications take precedence over bundled models, frameworks, and operating systems.
// Match only the image title; descriptions list dependencies and are not brand identifiers.
const IMAGE_BRAND_RULES = [
  ['comfyui', /(?:^|[^a-z0-9])(?:comfyui)(?=$|[^a-z])/i],
  ['n8n', /(?:^|[^a-z0-9])(?:n8n)(?=$|[^a-z])/i],
  ['opencode', /(?:^|[^a-z0-9])(?:open[ -]?code)(?=$|[^a-z])/i],
  ['ragflow', /(?:^|[^a-z0-9])(?:ragflow)(?=$|[^a-z])/i],
  ['autogen', /(?:^|[^a-z0-9])(?:autogen)(?=$|[^a-z])/i],
  ['llamafactory', /(?:^|[^a-z0-9])(?:llama[ -]factory)(?=$|[^a-z])/i],
  ['llamacpp', /(?:^|[^a-z0-9])(?:llama\.cpp)(?=$|[^a-z])/i],
  ['openwebui', /(?:^|[^a-z0-9])(?:open[ -]?webui)(?=$|[^a-z])/i],
  ['openclaw', /(?:^|[^a-z0-9])(?:openclaw)(?=$|[^a-z])/i],
  ['gpustack', /(?:^|[^a-z0-9])(?:gpustack)(?=$|[^a-z])/i],
  ['litellm', /(?:^|[^a-z0-9])(?:litellm)(?=$|[^a-z])/i],
  ['sglang', /(?:^|[^a-z0-9])(?:sglang)(?=$|[^a-z])/i],
  ['vllm', /(?:^|[^a-z0-9])(?:vllm)(?=$|[^a-z])/i],
  ['ollama', /(?:^|[^a-z0-9])(?:ollama)(?=$|[^a-z])/i],
  ['chatdev', /(?:^|[^a-z0-9])(?:chatdev)(?=$|[^a-z])/i],
  ['chandra', /(?:^|[^a-z0-9])(?:chandra)(?=$|[^a-z])/i],
  ['apmic', /(?:^|[^a-z0-9])(?:apmic|privai)(?=$|[^a-z])/i],
  ['breeze', /(?:^|[^a-z0-9])(?:breeze|breezyvoice)(?=$|[^a-z])/i],
  ['ornith', /(?:^|[^a-z0-9])(?:ornith)(?=$|[^a-z])/i],
  ['laguna', /(?:^|[^a-z0-9])(?:laguna)(?=$|[^a-z])/i],
  ['deepseek', /(?:^|[^a-z0-9])(?:deepseek)(?=$|[^a-z])/i],
  ['qwen', /(?:^|[^a-z0-9])(?:qwen)(?=$|[^a-z])/i],
  ['glm', /(?:^|[^a-z0-9])(?:glm)(?=$|[^a-z])/i],
  ['gemma', /(?:^|[^a-z0-9])(?:gemma)(?=$|[^a-z])/i],
  ['llama', /(?:^|[^a-z0-9])(?:llama)(?=$|[^a-z])/i],
  ['openai', /(?:^|[^a-z0-9])(?:gpt[ -]?oss)(?=$|[^a-z])/i],
  ['wan', /(?:^|[^a-z0-9])(?:wan)(?=$|[^a-z])/i],
  ['openmpi', /(?:^|[^a-z0-9])(?:open[ -]?mpi)(?=$|[^a-z])/i],
  ['ultralytics', /(?:^|[^a-z0-9])(?:ultralytics|yolov(?:5|8|11))(?=$|[^a-z])/i],
  ['nvidia', /(?:^|[^a-z0-9])(?:isaac[ -]?(?:sim|lab))(?=$|[^a-z])/i],
  ['pytorch', /(?:^|[^a-z0-9])(?:pytorch|torch)(?=$|[^a-z])/i],
  ['windows', /(?:^|[^a-z0-9])(?:windows)(?=$|[^a-z])/i],
  ['rockylinux', /(?:^|[^a-z0-9])(?:rocky[ -]?linux)(?=$|[^a-z])/i],
  ['ubuntu', /(?:^|[^a-z0-9])(?:ubuntu)(?=$|[^a-z])/i],
  ['docker', /(?:^|[^a-z0-9])(?:docker)(?=$|[^a-z])/i],
  ['nvidia', /(?:^|[^a-z0-9])(?:cuda)(?=$|[^a-z])/i],
] as const

export type ImageBrand = (typeof IMAGE_BRAND_RULES)[number][0] | 'glows'

export function getImageBrand(name: string): ImageBrand {
  return IMAGE_BRAND_RULES.find(([, pattern]) => pattern.test(name))?.[0] ?? 'glows'
}
